import {
  VALIDATE_EMAIL,
  VALIDATE_FIRST_NAME,
  VALIDATE_LAST_NAME,
  VALIDATE_PASSWORD,
  VALIDATE_PASSWORD_CONFIRMATION,
  SEND_SIGN_UP_REQUEST,
  RECEIVE_SIGN_UP_RESPONSE,
  RECEIVE_SIGN_UP_ERROR,
  CLEAR_SIGN_UP_ERROR
} from './signUpActions'

const initialState = {
  inputValues: {
    email: '',
    firstName: '',
    lastName: '',
    password: '',
    confirmPassword: ''
  },
  validationErrors: {},
  isSignUpRequestPending: false,
  isSignUpRequestSuccessful: false,
  isSignUpRequestError: false
}

export default (
  state = initialState,
  action
) => {
  const newState = { ...state }
  switch (action.type) {
    case SEND_SIGN_UP_REQUEST:
      return { ...state, isSignUpRequestPending: true }

    case RECEIVE_SIGN_UP_RESPONSE:
      return {
        ...state,
        isSignUpRequestPending: false,
        isSignUpRequestSuccessful: true,
        isSignUpRequestError: false
      }

    case RECEIVE_SIGN_UP_ERROR:
      return {
        ...state,
        isSignUpRequestPending: false,
        isSignUpRequestSuccessful: false,
        isSignUpRequestError: true
      }

    case CLEAR_SIGN_UP_ERROR:
      return { ...state, isSignUpRequestError: false }

    case VALIDATE_EMAIL:
      newState.inputValues.email = action.newInput
      if (!action.newInput) {
        newState.validationErrors = { ...state.validationErrors, email: 'email is required' }
      } else if (!/(\w)+@(\w)+\.{1}\w{2,5}/.test(action.newInput)) {
        newState.validationErrors = { ...state.validationErrors, email: 'invalid email' }
      } else {
        newState.validationErrors = { ...state.validationErrors, email: undefined }
      }
      return newState

    case VALIDATE_FIRST_NAME:
      newState.inputValues.firstName = action.newInput
      if (!action.newInput) {
        newState.validationErrors = { ...state.validationErrors, firstName: 'firstName is required' }
      } else {
        newState.validationErrors = { ...state.validationErrors, firstName: undefined }
      }
      return newState

    case VALIDATE_LAST_NAME:
      newState.inputValues.lastName = action.newInput
      if (!action.newInput) {
        newState.validationErrors = { ...state.validationErrors, lastName: 'lastName is required' }
      } else {
        newState.validationErrors = { ...state.validationErrors, lastName: undefined }
      }
      return newState

    case VALIDATE_PASSWORD:
      newState.inputValues.password = action.newInput
      if (!action.newInput) {
        newState.validationErrors = { ...state.validationErrors, password: 'password is required' }
      } else if (action.newInput.length < 6 || action.newInput.length > 100) {
        newState.validationErrors = { ...state.validationErrors, password: 'invalid password' }
      } else {
        newState.validationErrors = { ...state.validationErrors, password: undefined }
      }
      return newState

    case VALIDATE_PASSWORD_CONFIRMATION:
      newState.inputValues.confirmPassword = action.newInput
      if (
        state.validationErrors.password ||
        action.newInput !== state.inputValues.password
      ) {
        newState.validationErrors = { ...state.validationErrors, confirmPassword: 'passwords dont match' }
      } else {
        newState.validationErrors = { ...state.validationErrors, confirmPassword: undefined }
      }
      return newState

    default: return state
  }
}
